export default function setTabsTermos() {
  let id = document.location.hash;
  let tabs = document.querySelectorAll('[data-tab]');
  let contents = document.querySelectorAll('.content');

  if (id && tabs.length > 0) {
    tabs.forEach((tab) => {
      tab.classList.remove('-active');
    });

    contents.forEach((content) => {
      content.classList.remove('-active');
    });

    let tabTarget = document.querySelector('a[href="' + id + '"]');
    let contentTarget = document.querySelector(id);

    if (tabTarget) {
      tabTarget.classList.add('-active');
      contentTarget.classList.add('-active');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        if (window.innerWidth < 768) {
          const sidePositioning = tabTarget.offsetLeft - (window.innerWidth / 2) + (tabTarget.offsetWidth / 2);
          tabTarget.parentElement.scrollTo({ left: sidePositioning, behavior: 'smooth' });
        }

      }, 20);
    }
  }

  if (tabs.length > 0) {
    tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => {
        event.preventDefault();
        let activeTab = document.querySelector('.tab-btn.-active');
        let activeContet = document.querySelector('.content.-active');

        if (activeTab) {
          activeTab.classList.remove('-active');
        }

        if (activeContet) {
          activeContet.classList.remove('-active');
        }

        let tabId = tab.getAttribute('href');
        let tabTarget = document.querySelector('a[href="' + tabId + '"]');
        let contentTarget = document.querySelector(tabId);

        if (tabTarget) {
          tabTarget.classList.add('-active');
          contentTarget.classList.add('-active');
          setTimeout(() => {
            window.scrollTo({ top: 0, behavior: 'smooth' });

            if (window.innerWidth < 768) {
              const sidePositioning = tabTarget.offsetLeft - (window.innerWidth / 2) + (tabTarget.offsetWidth / 2);
              tabTarget.parentElement.scrollTo({ left: sidePositioning, behavior: 'smooth' });
            }
            
          }, 20);
        }
      });
    });
  }
}
